import * as React from 'react';
import ErrorPage from 'pages/ErrorPage';

export interface ErrorBoundaryProps {
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  public state: Readonly<State> = {
    hasError: false,
  };

  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  public render() {
    const { children } = this.props;
    const { hasError } = this.state;

    return hasError ? <ErrorPage /> : <>{children}</>;
  }
}
